<template>
    <div v-if="join" id="appleid-signin" data-type="sign-up" v-bind="buttonAttrs" />
    <div v-else id="appleid-signin" data-type="sign-in" v-bind="buttonAttrs" />
    <!-- <v-layout column align-center justify-space-between>
        <v-avatar size="48" color="black">
            <v-img contain max-width="16px" src="/images/icon/icon-a@2x.png"></v-img>
        </v-avatar>
        <div v-if="!hidesLabel" class="font-size-12 mt-6 mb-n2">{{ label }}</div>
    </v-layout> -->
</template>

<script>
const buttonAttrs = {
    "data-mode": "center-align",
    "data-color": "black",
    "data-border": "false",
    "data-border-radius":"50",
    "data-width":"375",
    "data-height":"48",
    "data-logo-size":"small",
};
export default {
    props: {
        clientId: { type: String, default: "" },
        join: { type: Boolean, default: false },
        hidesLabel: { type: Boolean, default: false },
        // label: { type: String, default: "애플 로그인" },
    },
    data: () => ({
        buttonAttrs,
    }),
    computed: {
        redirectURI: function () {
            return `${document.location.protocol}//${document.location.hostname}/oauth/apple`;
        },
    },
    mounted() {
        const { clientId, redirectURI } = this;
        AppleID.auth.init({
            clientId,
            scope: "email",
            redirectURI: "https://honpyun.com/oauth/apple",
        });
    },
};
</script>

<style scoped>
#appleid-signup,
#appleid-signin{
    display: flex;
    justify-content: center;
}
</style>